import React from "react";
import styles from "./Details.module.css";
import { Input } from "../../../../common/Input";
import { ButtonFooter } from "../../../../common/ButtonFooter";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { PayWithButton } from "../../../../common/PayWithButton";
import { KlashaSelect, Option } from "../../../../common/KlashaSelect";
import { CustomPhoneInput } from "../../../../common/PhoneInput";
import { WalletPayProps } from "../../../Wallet";

interface DetailsProps {
  networks: Option[];
  onPay: (data?: WalletPayProps) => void;
  onNetworkChange: (opt: string) => void;
  defaultName: string;
  defaultPhone?: string;
  defaultEmail?: string;
  isLoading?: boolean;
  isNetworkDisabled?: boolean;
  emailError?: string;
  setEmailError?: React.Dispatch<React.SetStateAction<any>>;
}

export const Details = ({
  networks,
  onPay,
  onNetworkChange,
  defaultName,
  defaultPhone,
  defaultEmail,
  isLoading,
  isNetworkDisabled,
  emailError,
  setEmailError,
}: DetailsProps) => {
  const { handleSubmit, control, register } = useForm();
  const [fullName, setFullName] = useState(defaultName);
  const [email, setEmail] = useState(defaultEmail);
  const [phoneVal, setPhoneVal] = useState(defaultPhone);

  return (
    <div className={styles.container}>
      <form onSubmit={handleSubmit(onPay)}>
        <div className={styles.form}>
          <div className={styles.dualInput}>
            <Input
              value={fullName}
              onChange={(e: any) => setFullName(e.target.value)}
              inputId="fullname"
              type="text"
              label="Full name"
              // required
              register={register}
              placeholder=""
            />

            <KlashaSelect
              label="Network"
              onChange={onNetworkChange}
              options={networks}
              // required
            />
          </div>
          <div className={styles.dualInput}>
            <Input
              register={register}
              value={email}
              onChange={(e: any) => setEmail(e.target.value)}
              inputId="email"
              label="Email address"
              // required
              errorText={emailError}
              setErrorText={setEmailError}
              placeholder=""
            />

            <CustomPhoneInput
              register={register}
              inputId="phone"
              type="text"
              label="Phone number"
              placeholder=""
              control={control}
              value={phoneVal}
              setVal={setPhoneVal}
              // required
            />
          </div>
        </div>
        <ButtonFooter showNote>
          <PayWithButton
            isLoading={isLoading}
            isDisabled={
              !phoneVal?.length ||
              isNetworkDisabled ||
              !email?.length ||
              !fullName?.length
            }
          />
        </ButtonFooter>
      </form>
    </div>
  );
};
